import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import LazyLoad from "react-lazy-load";

import FunnelOnTableWithFilters from "./FunnelOnTableWithFilters";
import RegularFunnelWithClicksInBars from "./RegularFunnelWithClicksInBars";

class NewRegularFunnelContainer extends Component {
  constructor() {
    super();

    this.state = {
      labelFilter: "",
      typeFilter: "",
      results: {}
    };

    this.changeFilter = this.changeFilter.bind(this);
    this.loadTotal = this.loadTotal.bind(this);
  }
  changeFilter(label, typeFilter) {
    if (label === this.state.labelFilter) {
      this.setState({
        labelFilter: ""
      });
      return;
    }
    this.setState({
      labelFilter: label,
      typeFilter
    });
  }
  loadTotal(results) {
    this.setState({
      results
    });
  }
  render() {
    return (
      <Row>
        <Col md={12}>
          <LazyLoad>
            <RegularFunnelWithClicksInBars
              {...this.props}
              labelFilter={this.state.labelFilter}
              typeFilter={this.state.typeFilter}
              loadTotal={this.loadTotal}
            />
          </LazyLoad>
        </Col>
        <Col md={12}>
          <FunnelOnTableWithFilters
            {...this.props}
            changeFilter={this.changeFilter}
            totalResults={this.state.results}
          />
        </Col>
      </Row>
    );
  }
}

export default NewRegularFunnelContainer;



// WEBPACK FOOTER //
// ./src/components/charts/Funnels/NewRegularFunnelContainer.js